import React, { Component } from "react";
import {Button} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";

import "./../../CSS/auth-styles.css";

import HeaderPanel from "../Home/Components/HeaderPanel";
import ModalContextMenu from "../Home/Components/ModalContextMenu";


export default class ErrorPage
 extends Component {
  constructor(props) {
    super(props);

    this.state = 
    {

    }

    this.onContextMenuRequest = this.onContextMenuRequest.bind(this);
    this.onContextMenuCloseRequest = this.onContextMenuCloseRequest.bind(this);
  }


  onContextMenuRequest() {
    this.setState({ showContextMenu: true });
  }
  
  onContextMenuCloseRequest() {
    this.setState({ showContextMenu: false });
  }




  render()
  {
    return (
      <div style={{position: "absolute", width: "50vw", height: "50vh", top: "30%", left: "30%"}}>
      <div id="errormsgbox">
        <div id="errorLabel" style={{color: "lightgrey"}}>The System generated an Unexpected Error</div>
        <div id="errorMsg" style={{color: "yellow"}}>{this.props.systemErrorMsg}</div>
        <div id="authButtonLayer" style={{alignContent: "center"}}>
          <br/><br/>
          <Button id="authButton" onClick={(e)=>this.props.onLogoutRequest(e)}><FontAwesomeIcon icon={faPowerOff} color = "yellow"/>Reset</Button>
        </div>
      </div>
      </div>

    )
  }

}